import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import {
    ICompanyEntity,
    IPrSubmissionRegZecEntity,
    PrSubmissionRegZecEntity,
    RegZecEmployeeEntity,
    RegZecEmploymentEntity
} from "@odata/GeneratedEntityTypes";
import { CountryCode, PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";
import { searchAddress } from "@utils/address.utils";
import { isObjectEmpty } from "@utils/general";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";

class PrSubmissionRegZecFormView extends SubmissionsFormViewForExtend<IPrSubmissionRegZecEntity> {
    typeCode = PrSubmissionTypeCode.EmployeeRegistration;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee = createPath(PrSubmissionRegZecEntity.Employee, RegZecEmployeeEntity.Employee);

    typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;

        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            const company = storage.context.getCompany() as ICompanyEntity;
            entity.Company.Company = { Id: company.Id };
            if (entity.Employment?.City && !entity.Employment.CityCode) {
                this.defaultCityCode();
            }

        } else {
            // set local context for showing/hiding fields

        }

        return Promise.all([...promises, super.typeSpecificOnAfterLoad(isNew)]).then();
    }

    defaultCityCode() {
        const { storage } = this.props;
        const city = storage.getValueByPath(createPath(PrSubmissionRegZecEntity.Employment, RegZecEmploymentEntity.City));
        if (city) {
            searchAddress(city).then(data => {
                if (data?.length === 1) {
                    const addressCode = data[0].AddressCode;
                    storage.setValueByPath(createPath(PrSubmissionRegZecEntity.Employment, RegZecEmploymentEntity.CityCode), addressCode);
                    storage.refreshFields(true);
                }
            });
        }
    }

    handleChange(e: ISmartFieldChange): void {
        const { storage } = this.props;

        super.handleChange(e);
        // keep after storage -> handleChange to have updated data
    }

    onBeforeSave(data?: IPrSubmissionRegZecEntity): IPrSubmissionRegZecEntity {
        data = super.onBeforeSave(data);

        if (!isObjectEmpty(data.Employee.CzechAddress) && !data.Employee.CzechAddress?.CountryCode) {
            data.Employee.CzechAddress.CountryCode = CountryCode.CzechRepublic;
        }

        return data;
    }
}

export default withPermissionContext(PrSubmissionRegZecFormView);
